import { Component, Input } from '@angular/core';
import { BaseViewComponent, DesignBlockImageScope, DesignBlockScope, WebsiteBlockImageAction, WebsitePageScope } from '@sb/library/base';
import { WebsiteBlockDisplayItem, WebsiteBlockTextAndMediaDisplayItem, WebsiteBlockTextAndMediaImageDisplayItem, WebsiteBlockTextAndMediaType } from '@sb/library/data-models';

@Component({
    selector: 'lib-gallery-column-design-block-item',
    templateUrl: './gallery-column-design-block-item.component.html',
    styleUrls: ['./gallery-column-design-block-item.component.scss'],
})
export class GalleryColumnDesignBlockItemComponent extends BaseViewComponent implements DesignBlockImageScope {

    Scope = this.SetScope({
        Implements: DesignBlockImageScope,
        Requires: [DesignBlockScope, WebsitePageScope]
    });

    @Input() imageData!: WebsiteBlockTextAndMediaImageDisplayItem;

    override ngOnInit(): void {
        super.ngOnInit();

        if (!WebsiteBlockDisplayItem.IsTextAndMedia(this.Scope.websiteBlockData)) {
            throw Error('GalleryColumnDesignBlockItemComponent used in wrong context');
        }
    }

    get disableRemoveCard(): boolean {
        return this.websiteBlockData.Images.length <= 1;
    }

    get blockHasCard(): boolean {
        return this.kind == WebsiteBlockTextAndMediaType.GalleryCircleCardColumn || this.kind == WebsiteBlockTextAndMediaType.GallerySquareCardColumn;
    }

    get kind(): WebsiteBlockTextAndMediaType {
        return this.websiteBlockData.TextAndMediaType;
    }

    get websiteBlockData(): WebsiteBlockTextAndMediaDisplayItem {
        return this.Scope.websiteBlockData as WebsiteBlockTextAndMediaDisplayItem;
    }

    get WebsiteBlockImageAction(): typeof WebsiteBlockImageAction {
        return WebsiteBlockImageAction;
    }

    get WebsiteBlockTextAndMediaType(): typeof WebsiteBlockTextAndMediaType {
        return WebsiteBlockTextAndMediaType;
    }
}
